import { Component, Output, EventEmitter } from '@angular/core';
import { Router} from '@angular/router';
import { AuthService } from './services/auth.service';
import { Location } from '@angular/common';

import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
 /**
 * @event notify  Para Geocercas.
 * @event notifykmz  Para Kmz.
 * @event units  Para las unidades.
 * @event operator  Para operadores.
 * @event usuarios  Para usuarios.
 **/
  @Output() notify = new EventEmitter<any>();
  @Output() notifykmz = new EventEmitter<any>();
  @Output() units = new EventEmitter<any>();
  @Output() operator = new EventEmitter<any>();
  @Output() usuarios = new EventEmitter<any>();
  /**
   * Variables
  **/
  public comandos: boolean;
  public nombre: String;
  public logo: String;


  constructor(public auth: AuthService, private router: Router, public jwtHelper: JwtHelperService, private location: Location) {
    /**
     * Valida si tiene una sesión activa
     * Activa: revisa los permisos que tiene el usuario
     * Inactiva: Revisa la url te puede enviar a recuperar contraseña o al login.
    **/
    if (this.auth.loggedIn) {
      router.navigate(['/']);
      if (this.jwtHelper.decodeToken(localStorage.getItem('access_token')).permisoID == 4) {
        this.comandos = false;
      } else {
        this.comandos = true;
        this.nombre = this.jwtHelper.decodeToken(localStorage.getItem('access_token')).nombre;
        this.logo = this.jwtHelper.decodeToken(localStorage.getItem('access_token')).logo;
      }
    } else {
      const ruta = this.location.path().split('/');
      if (ruta.length == 3) {
        router.navigate(['restablecer-contrasena', ruta[2]]);
      } else {
        router.navigate(['login']);
      }
    }

  }

  /**
   * Cerramos sessión y redirigimos al login
  **/
  logout() {
    this.auth.logout();
    this.router.navigate(['login']);
  }
  /**
   * En dispositivos pequeños abre y cierra el menú
  **/
  abrirDispositivos() {
    $('#page').toggleClass('openMenu');
  }
}
